import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'components/utility/react-modal'

export function SubmissionErrorModal({ isOpen, errors = null, onClose }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="submission-modal">
      <ModalHeader>
        <i className="fa-thin fa-circle-exclamation dome-color-red-alert submission-modal-icon" />
        <span className="dome-h2 dome-color-red-alert">submission failed</span>
      </ModalHeader>

      <ModalBody className="dome-gap12">
        <span className="dome-p1 dome-color-dark-grey">
          Something went wrong while submitting. Please try again or contact support if the issue persists.
        </span>
        {errors && errors.length > 0 && (
          <ul className="dome-d-flex dome-flex-column dome-gap3" style={{ paddingLeft: 18, margin: 0 }}>
            {errors.map((e, idx) => (
              <li key={idx} className="dome-p2 dome-color-dark-grey">
                {e}
              </li>
            ))}
          </ul>
        )}
      </ModalBody>

      <ModalFooter className="submission-error-footer">
        <button type="button" onClick={onClose} className="dome-btn dome-btn-base dome-btn-grey-stroke">
          OK
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default SubmissionErrorModal
